import ChannelsBannerListItem from '../../../components/ChannelsBanner/ChannelsBannerListItem/index';
import { Channel, RootState } from '../../../interfaces';
import StickyHeader from '../../app/StickyHeader';
import i18n from '../../../i18n';
import styles from './WatchTv.module.scss';
import { useSelector, shallowEqual } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { routes } from '../../../config';
import { getCatchupEnabledChannels } from '../../../utils/programArchiveUtils';
import Footer from '../../../components/Footer';
import { isEmpty } from 'lodash';
import { useChannels } from '../../../queries/channels/queries';

function WatchTv() {
  const { data: channels } = useChannels();
  const store = useSelector(
    (state: RootState) => ({
      channels: state.channelsReducer.channels,
      playbills: state.channelsReducer.playbills,
      favoriteChannels: state.channelsReducer.favoriteChannels,
    }),
    shallowEqual,
  );
  const match = useRouteMatch();
  const isProgramArchive = (): boolean => {
    let programArchiveUrl = `${routes.unmanaged.base}${routes.watchTv.base}${routes.watchTv.programarchive}`;
    return match.url === programArchiveUrl;
  };

  return (
    <>
      <StickyHeader />
      <h3 className={styles.watchTvHeaderWrapper}>
        {isProgramArchive() ? i18n.t<string>('programarchive') : i18n.t<string>('watch tv')}
      </h3>
      {isProgramArchive() ? (
        <ProgramArchiveChannelsList channels={store.channels} />
      ) : (
        <TvChannels channels={channels} />
      )}
      <Footer />
    </>
  );
}
export default WatchTv;

function ProgramArchiveChannelsList({ channels }: { channels: Channel[] }) {
  if (isEmpty(channels)) {
    return null;
  }

  const paChannels = getCatchupEnabledChannels(channels);

  return (
    <ul className={styles.watchTvChannelsContainer}>
      {paChannels.map((channel) => {
        return <ChannelsBannerListItem isProgramArchive={true} key={channel.contentId} channel={channel} />;
      })}
    </ul>
  );
}

function TvChannels({ channels }: { channels?: Channel[] }) {
  console.log('tv channels');
  if (!channels) {
    console.log('no channles');
    return (
      <>
        {Array.from({ length: 15 }).map((_, index: number) => {
          return <ChannelsBannerListItem.Skeleton index={index} key={index} />;
        })}
      </>
    );
  }
  return (
    <ul className={styles.watchTvChannelsContainer}>
      {channels.map((channel) => {
        return <ChannelsBannerListItem isProgramArchive={false} key={channel.contentId} channel={channel} />;
      })}
    </ul>
  );
}
